<div *ngIf="!isLoading" class="canned-service-item bb-gray flex-start-start" [ngClass]="{ 'new-service-item': isLast }">
  <ng-container *ngIf="qtqAddOn && isQTQAddOnEnable">
    <!-- Item checked -->
    <div class="item add-on pl-1 pr-2 align-self-center">
      <app-checkbox [isChecked]="serviceItem.checked" [checkState]="0" (click)="pushToList()"> </app-checkbox>
    </div>

    <!-- Item auto adjust qty with tire -->
    <div class="item adj-qty pl-1 pr-2 align-self-center">
      <app-switch-pill id="adj-w-tire-qty" position="end" [isActive]="serviceItem.adjQtyWithTire" [fontSize]="12"
        (appChange)="handleChange('adjQtyWithTire', $event)">
      </app-switch-pill>
    </div>
  </ng-container>

  <!-- Item Type -->
  <div class="item type position-relative" [ngClass]="{ 'expandable-item': serviceItem?.type === 'bundle' }">
    <i *ngIf="serviceItem?.type === 'bundle'" class="expand-icon p-1 pointer fal"
      [ngClass]="{ 'fa-chevron-up': serviceItem?.isExpanded, 'fa-chevron-down': !serviceItem?.isExpanded }"
      (click)="serviceItem.isExpanded = !serviceItem.isExpanded"></i>

    <app-auto-complete name="item-type-{{index}}" field="label" highlightField="highlightField"
      styleClassInputWrapper="pl-0" styleClassInput="p-6p pl-0" styleClassListWrapper="top-38"
      styleClassError="top-35 left-10" inactiveItemsKey="value" itemWidth="150px" scrollHeight="210px"
      placeholder="Select *" id="item-type-{{ index }}" listId="item-type-list-{{ index }}" [selectTextOnFocus]="true"
      [delay]="10" [hasBorderBottomOnActive]="errors?.type" [minSearchLength]="1"
      [theme]="errors?.type ? 'primary' : 'light'" [value]="itemTypeLabel[serviceItem?.type]"
      [leftIcon]="serviceItem?.type === 'partLookUp' ? 'mr-2 lookup-image-item' : ''"
      [suggestions]="itemTypeSuggestions" [isDropdownIconVisible]="true" [selectionOnTab]="true"
      [disabled]="isSubItem || serviceItem?.itemId" [highlightFirstSelectedValue]="true"
      (appSelect)="handleChange('type', $event?.value)" (appFocus)="handleFocus('type')" (appEnter)="handleBlur('type')"
      (appBlur)="handleBlur('type')" (appTabPress)="handleBlur('type')"
      (appCompletedMethod)="handleItemTypeSearch($event)" (appBlur)="handleBlur('type')"
      (appClear)="handleClear('type')">
      <ng-template appTemplate="item" let-item let-query="query">
        <div class="item-list">
          {{ item.label }}
          <span class="ml-1 lookup-image-dropdown-item" *ngIf="item.value === 'partLookUp'"> </span>
        </div>
      </ng-template>
    </app-auto-complete>
  </div>

  <!-- Item Name -->
  <div class="item name flex-row" [ngClass]="{ 'parts-lookup': serviceItem?.type === 'partLookUp' }">
    <div *ngIf="serviceItem?.type === 'other' || serviceItem?.type === 'sublet'; else searchableItem">
      <app-input styleClassInput="p-6p pl-0" styleClassInputWrapper="pl-0" styleClassError="top-35 left-10"
        [theme]="errors?.title ? 'primary' : 'light'" [placeholder]="itemTypePlaceholder[serviceItem?.type]"
        [hasBorderBottomOnActive]="errors?.title"
        [value]="currentLang === 'fr' ? ( serviceItem?.titleFR || serviceItem?.title ) : ( serviceItem?.title || serviceItem?.titleFR )"
        [isInvalid]="errors?.title" [disabled]="isSubItem" [fontSize]="12" (appChange)="handleChange('title', $event)"
        (appFocus)="handleFocus('title')" (appChange)="handleFieldChange()">
      </app-input>
    </div>

    <ng-template #searchableItem>
      <app-auto-complete styleClassInput="p-6p pl-0" class="w-100" styleClassInputWrapper="pl-0"
        styleClassListWrapper="top-38" styleClassError="top-35 left-10" itemWidth="300px" inactiveItemsKey="status"
        scrollHeight="184px"
        [hasEditableField]="['part', 'labor', 'hazmatFee', 'tire', 'bundle'].includes(serviceItem?.type)"
        [editFieldLabel]="itemCreateLabel[serviceItem?.type]" [theme]="errors?.title ? 'primary' : 'light'"
        [placeholder]="itemTypePlaceholder[serviceItem?.type]" [isLoading]="isSearching"
        [allowMultiline]="!focus?.title" [maxAutoGrowHeight]="96" [disabled]="isSubItem"
        textAreaId="IT{{ serviceItem?.itemId }}{{ index }}" [showDisabledIcon]="false" [selectionOnTab]="true"
        [autoFocus]="focus?.title" [selectInactiveItems]="false" [hasBorderBottomOnActive]="errors?.title"
        [isDropdownIconVisible]="true"
        [value]="currentLang === 'fr' ? ( serviceItem?.titleFR || serviceItem?.title || '' ) : ( serviceItem?.title || serviceItem?.titleFR || '' )"
        [fontSize]="12" [suggestions]="itemSuggestions" [isInvalid]="errors?.title" [isDropdownIconVisible]="true"
        [closeOnSelection]="true" (appFocus)="handleFocus('title')" (appClickOutside)="handleBlur('title')"
        (appSelect)="handleSelect('title', $event); handleFieldChange()" (appClear)="handleClear(serviceItem)"
        (appCompletedMethod)="handleItemSearch($event)" (appClickCreate)="handleCreateItem($event)">
        <ng-template let-item let-query="query" appTemplate="item">
          <div *ngIf="serviceItem?.type !== 'partLookUp'" class="flex-between-center"
            [ngClass]="{ disabled: !item?.status, 'parts-lookup': serviceItem?.type === 'partLookUp' }">
            <div class="flex-start-center width-60p">
              <div class="flex-center-center mr-2">
                <i class="{{ itemTypeIcons[serviceItem?.type] }} font-gray-75"></i>
              </div>

              <div class="flex-column flex-center-start service-item-details search-item"
                [ngClass]="{ disabled: !item?.status }" (click)="!item?.status ? $event.stopPropagation() : null">
                <span class="flex-start-center font-secondary-700 font-600 width-100p text-truncate">
                  <div class="text-truncate font-12" *ngIf="!companyLocalization"
                    [innerHTML]="highlighedSearchText(item?.type === 'part' ? item?.itemTitle : item?.title, query)">
                  </div>
                  <div class="text-truncate font-12" *ngIf="companyLocalization && item.searchBy === 'title'"
                    [innerHTML]="highlighedSearchText(item?.type === 'part' ? item?.itemTitle : item?.title, query)">
                  </div>
                  <div class="text-truncate font-12" *ngIf="companyLocalization && item.searchBy === 'titleFR'"
                    [innerHTML]="highlighedSearchText(item?.type === 'part' ? item?.itemTitleFR : item?.titleFR, query)">
                  </div>
                </span>

                <span class="font-11 font-gray-55 tire-description text-truncate" *ngIf="!companyLocalization"
                  [pTooltip]="item?.notes || item?.description" tooltipPosition="top" tooltipStyleClass="list-tooltip">
                  {{ item?.notes || item?.description || 'No description' }}
                </span>
                <span class="font-11 font-gray-55 tire-description text-truncate"
                  *ngIf="companyLocalization && item.searchBy === 'title'" [pTooltip]="item?.notes || item?.description"
                  tooltipPosition="top" tooltipStyleClass="list-tooltip">
                  {{ item?.notes || item?.description || 'No description' }}
                </span>
                <span class="font-11 font-gray-55 tire-description text-truncate"
                  *ngIf="companyLocalization && item.searchBy === 'titleFR'" [pTooltip]="item?.descriptionFR"
                  tooltipPosition="top" tooltipStyleClass="list-tooltip">
                  {{ item?.descriptionFR || 'No description' }}
                </span>
              </div>
            </div>

            <div class="flex-end-center width-30p">
              <div class="flex-column width-100p">
                <div *ngIf="serviceItem?.type !== 'bundle'; else bundleTopRight"
                  class="font-secondary-700 flex-between-center">
                  <span class="font-600">Price</span>
                  <span class="font-600">&nbsp;{{ item?.price | currency : usd }}</span>
                </div>

                <ng-template #bundleTopRight>
                  <div class="font-secondary-700 flex-end-center">Price&nbsp;&nbsp;{{ item?.flatRate || 0 | currency :
                    usd }}</div>
                </ng-template>

                <div *ngIf="serviceItem?.type !== 'bundle'; else bundleBottomRight"
                  class="font-11 font-gray-55 flex-between-center">
                  <span>Cost</span>
                  <span>&nbsp;{{ item?.cost | currency : usd }}</span>
                </div>

                <ng-template #bundleBottomRight>
                  <div class="font-secondary-700 flex-end-center">Items:&nbsp;&nbsp;{{ item?.itemTotal?.totalItemCount
                    || 0 | number : '1.2-2' }}</div>
                </ng-template>
              </div>
            </div>
          </div>
          <div *ngIf="serviceItem?.type === 'partLookUp'">
            {{ item?.name }}
          </div>
        </ng-template>
      </app-auto-complete>
    </ng-template>
    <ng-container *ngIf="!isLast && !isSubItem && serviceItem?.itemId">
      <div class="remove-item flex-center-center z-index-10" (click)="handleDelete()">
        <i class="fal fa-times" [ngClass]="{ 'font-primary': focus?.cross }"></i>
      </div>
    </ng-container>
  </div>

  <!-- Item Description -->
  <div class="item description">
    <app-textarea placeholder="Enter description" styleClassInput="pl-0" styleClass="pl-0" textAreaId="IT{{ index }}"
      [maxLength]="10000" [selectTextOnFocus]="true" [rows]="1" [autoGrow]="true" [maxAutoGrowHeight]="96"
      [theme]="focus?.description ? 'primary' : 'light'" [autoFocus]="focus.description" [fontSize]="12"
      [disabled]="serviceItem?.type === 'bundle' || isSubItem || !serviceItem?.type || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId)"
      [value]="currentLang === 'fr' ? serviceItem?.descriptionFR || serviceItem?.description : serviceItem?.description || serviceItem?.descriptionFR"
      (appChange)="handleChange('description', $event)" (appFocus)="handleFocus('description')"
      (appBlur)="handleBlur('description')" (appChange)="handleFieldChange()">
    </app-textarea>
  </div>

  <!-- Item Taxable -->
  <div class="item taxable">
    <app-dropdown field="label" styleClassInput="p-6p pl-0" itemWidth="110px" styleClassDropdownList="top-38"
      styleClassSelectedView="p-6p pl-0" [setPositionDynamically]="true" [theme]="focus?.isTaxable ? 'light' : 'light'"
      [fontSize]="12" [hasBorderBottomOnActive]="false" placeholder="Select*" [options]="taxableOptions"
      [setPositionDynamically]="false" [isDropdownIconVisible]="true" [hidden]="serviceItem?.type === 'bundle'"
      [disabled]="serviceItem?.type === 'bundle' || isSubItem || serviceItem?.isPassThroughTax"
      [value]="serviceItem?.isTaxable ? taxableOptions[0] : taxableOptions[1]"
      (appSelect)="handleChange('isTaxable', $event?.value)" (appOpenDropdown)="handleFocus('isTaxable')"
      (appClickOutside)="handleBlur('isTaxable')" (appCloseDropdown)="handleBlur('isTaxable')">
    </app-dropdown>
  </div>

  <!-- Service Price -->
  <div class="item price">
    <app-input placeholder="$0.00" styleClassInputWrapper="pl-0" styleClassInput="p-6p pl-0" [hidden]="isSubItem"
      [theme]="focus?.price ? 'light' : 'light'" [allowDecimal]="focus?.price" [hasBorderBottomOnActive]="false"
      [selectTextOnFocus]="true" [fontSize]="12" [autoFocus]="focus?.price"
      [disabled]="serviceItem?.type === 'bundle' || isSubItem"
      [value]="focus?.price ? serviceItem.price : (serviceItem.price | currency : usd)"
      (appChange)="handleChange('price', $event)" (appChange)="handleFieldChange()" (appFocus)="handleFocus('price')" (appBlur)="handleBlur('price')">
    </app-input>
  </div>

  <!-- Service Quantity -->
  <div class="item qty">
    <app-input *ngIf="serviceItem?.type === 'tire'" styleClassInputWrapper="pl-0" styleClassInput="p-6p pl-0"
      placeholder="0" [allowDecimal]="true" [selectTextOnFocus]="true" [theme]="focus?.count ? 'light' : 'light'"
      [hasBorderBottomOnActive]="false" [fontSize]="12" [autoFocus]="focus.count"
      [disabled]="serviceItem?.type === 'bundle' || isSubItem"
      [value]="focus.count ? serviceItem.count : (serviceItem.count | number : '1.2-2')"
      (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')" (appKeyUp)="handleChange('count', $event)" (appChange)="handleFieldChange()">
    </app-input>

    <app-input
      *ngIf="!serviceItem.type || ['other', 'labor', 'part', 'tireStorage', 'hazmatFee', 'bundle', 'sublet'].includes(serviceItem?.type)"
      styleClassInputWrapper="pl-0" styleClassInput="p-6p pl-0" placeholder="0" [fontSize]="12"
      [theme]="focus?.count ? 'light' : 'light'" [autoFocus]="focus.count" [selectTextOnFocus]="true"
      tooltipPosition="top" [escape]="false" tooltipStyleClass="list-tooltip"
      pTooltip="{{ isTireStorage2Enabled && serviceItem?.type === 'tireStorage' && serviceItem?.pricingType === 'flatFee' ? 'To adjust the number of tires in this set, update the &quot;How many tires are we storing&quot;? field in the tire storage details modal.' : '' }}"
      [disabled]="serviceItem?.type === 'bundle' || isSubItem || (serviceItem?.type === 'tireStorage' && serviceItem.pricingType === 'flatFee')" [hasBorderBottomOnActive]="false"
      [value]="isTireStorage2Enabled && serviceItem?.type === 'tireStorage' && serviceItem.pricingType === 'flatFee' ?  (1 | number : '1.2-2') : focus.count ? serviceItem?.count : (serviceItem?.count | number : '1.2-2')" mask="0*.99"
      (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')" (appKeyUp)="handleChange('count', $event)" (appChange)="handleFieldChange()">
    </app-input>
  </div>

  <!-- Total Sub total -->
  <div class="item subtotal position-relative">
    <app-input theme="light" placeholder="$0.00" [allowDecimal]="false" styleClassInputWrapper="pl-0"
      styleClassInput="p-6p pl-0" [selectTextOnFocus]="true" [fontSize]="12"
      [value]="serviceItem?.subTotal | currency : usd" [disabled]="true" (appChange)="handleFieldChange()">
    </app-input>

    <i *ngIf="isSubItem" class="fas fa-info-circle subtotal-tooltip" tooltipPosition="bottom"
      pTooltip="Subtotal value shows flat rate price and its breakup for each sub item."></i>
  </div>

  <div class="item delete flex-end-center">
    <i *ngIf="!isLast && !isSubItem" class="far fa-trash font-gray-65" pTooltip="Delete" tooltipPosition="top"
      (click)="handleDelete()"></i>
  </div>
</div>